import { RefObject, useLayoutEffect } from 'react';
import { CONTENT_CONTAINER_CLASSNAME } from 'app/components/Core/ChakraContentContainer';

export const useFabPositionUpdate = (
  buttonRef: RefObject<HTMLButtonElement>
) => {
  useLayoutEffect(() => {
    const contentContainers = document.getElementsByClassName(
      CONTENT_CONTAINER_CLASSNAME
    );

    const contentContainer = contentContainers
      ? contentContainers[contentContainers.length - 1]
      : null;

    const updateButtonPosition = () => {
      if (!contentContainer || !buttonRef.current) {
        return;
      }

      const containerRect = contentContainer?.getBoundingClientRect();
      const button = buttonRef.current;
      const gap = window.innerWidth - containerRect.right;
      const right = gap > 0 ? gap : 0;

      button.style.right = `${right + 16}px`;
    };

    updateButtonPosition();

    const resizeObserver = new ResizeObserver(updateButtonPosition);

    if (contentContainer) {
      resizeObserver.observe(contentContainer);
    }

    window.addEventListener('resize', updateButtonPosition);

    return () => {
      window.removeEventListener('resize', updateButtonPosition);
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
